import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";

const CartCtx = createContext(null);
const KEY = "bo_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  const [deliveryMethod, setDeliveryMethod] = useState("delivery");
  const [quote, setQuote] = useState(null);
  const [district, setDistrict] = useState(null);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
    if (!items.length) { setQuote(null); return; }
    const t = setTimeout(() => {
      api.post("/cart/quote", { items: items.map(({ offer_id, qty }) => ({ offer_id, qty })), delivery_method: deliveryMethod, district })
        .then(({ data }) => setQuote(data)).catch(() => {});
    }, 250);
    return () => clearTimeout(t);
  }, [items, deliveryMethod, district]);

  const add = (product, offer, qty = 1) => {
    setItems((prev) => {
      const found = prev.find((i) => i.offer_id === offer.id);
      if (found) return prev.map((i) => (i.offer_id === offer.id ? { ...i, qty: Math.min(i.qty + qty, 50) } : i));
      return [...prev, { offer_id: offer.id, product_id: product.id, name: product.name, image: product.image,
        store_name: offer.store?.name, price: offer.price, qty, is_demo: product.is_demo }];
    });
    toast.success(`${product.name} adicionado ao carrinho`);
  };
  const setQty = (offerId, qty) =>
    setItems((prev) => (qty < 1 ? prev.filter((i) => i.offer_id !== offerId)
      : prev.map((i) => (i.offer_id === offerId ? { ...i, qty: Math.min(qty, 50) } : i))));
  const remove = (offerId) => setItems((prev) => prev.filter((i) => i.offer_id !== offerId));
  const clear = () => setItems([]);
  const count = items.reduce((s, i) => s + i.qty, 0);

  return (
    <CartCtx.Provider value={{ items, add, setQty, remove, clear, count, quote, deliveryMethod, setDeliveryMethod, setDistrict }}>
      {children}
    </CartCtx.Provider>
  );
}

export const useCart = () => useContext(CartCtx);
